import { TypedDocumentNode, gql } from '@apollo/client';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

import FlexCard from 'components/token/FlexCard';

import { Recommendation } from '../Recommendation';
import { CardRecommendation_anyCard } from './__generated__/index.graphql';
import { useFollowCardQuery } from './useFollowCardQuery';

const CardWrapper = styled.div`
  max-width: 224px;
  margin: 0 auto;
`;

type Props = {
  card: CardRecommendation_anyCard;
  chip?: ReactNode;
  onStatsClick: () => void;
  trackForYouClick: () => void;
};

export const CardRecommendation = ({
  card,
  chip,
  onStatsClick,
  trackForYouClick,
}: Props) => {
  const { isIosApp } = useIsMobileApp();
  const { anyPlayer } = card;
  const followRefetch = useFollowCardQuery(card.slug);
  return (
    <Recommendation
      player={anyPlayer}
      subscribable={card}
      card={card}
      chip={chip}
      onStatsClick={onStatsClick}
      followRefetch={followRefetch}
      trackForYouClick={trackForYouClick}
    >
      <CardWrapper>
        <FlexCard
          card={card}
          onClick={trackForYouClick}
          withLink={!isIosApp}
          width={320}
        />
      </CardWrapper>
    </Recommendation>
  );
};

CardRecommendation.fragments = {
  anyCard: gql`
    fragment CardRecommendation_anyCard on AnyCardInterface {
      slug
      anyPlayer {
        slug
        ...Recommendation_anyPlayer
      }
      ...Recommendation_anyCard
      ...FlexCard_anyCard
    }
    ${Recommendation.fragments.anyCard}
    ${Recommendation.fragments.anyPlayer}
    ${FlexCard.fragments.anyCard}
  ` as TypedDocumentNode<CardRecommendation_anyCard>,
};
